import React, { useContext, useEffect, useState, useRef } from "react";
import {
  Link,
  // ScrollRestoration, // Not used as useEffect handles scroll
  useNavigate,
  useParams,
} from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Thumbs, FreeMode } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import "swiper/css/free-mode";

import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { calculateDiscountPercentage } from "../utils/discountCalculater"; // Path thik ache kina dekhe neben
import VariantSelector from "../components/VariantSelector"; // Path thik ache kina dekhe neben
import toast from "react-hot-toast";
import { CartContext } from "../context/CartProvider";
import { WishListContext } from "../context/WishListProvider";

// Font Awesome icons (jemon ta age chilo)
// import '@fortawesome/fontawesome-free/css/all.min.css'; // Project-e globally import kora thakle ekhane dorkar nei
import ProductCard from './../components/Home/ProductCard';

const ProductDetails = () => {
  const { addToCart, cart } = useContext(CartContext);
  const { id } = useParams();
  const baseUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const [productData, setProductData] = useState(null); // Product data state
  const [reletedProduct, setReletedProduct] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [selectedVariant, setSelectedVariant] = useState(null);
  // const [addedItems, setAddedItems] = useState([]); // Ei state-ta ageo use hoyni

  const { addWishList, getExistingWishlist } = useContext(WishListContext);
  // productData load howar por isAddedWishlist check hobe
  const isAddedWishlist = productData?.product?._id
    ? getExistingWishlist(productData.product._id)
    : false;

  const [isShopOpen, setIsShopOpen] = useState(true);

  // --- Check Shop Status ---
  useQuery({
    queryKey: ["shop-status"],
    queryFn: async () => {
      try {
        const res = await axios.get(`${baseUrl}shop`);
        const status = res.data.shopData?.isOpen ?? true;
        setIsShopOpen(status);
        return res.data;
      } catch (error) {
        console.error("Failed to fetch shop status", error);
        return null;
      }
    },
  });

  const [thumbsSwiper, setThumbsSwiper] = useState(null); // For Swiper thumbnail gallery

  /* Zoom Logic Hooks - Moved to top to avoid conditional call errors */
  const [zoomState, setZoomState] = useState({
    show: false,
    x: 0,
    y: 0,
    img: ""
  });
  const mainImageRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsLoading(true);
    axios
      .get(`${baseUrl}productdetails/${id}`)
      .then((res) => {
        setProductData(res.data);
      })
      .catch((err) => {
        toast.error("Product details load kora jayni.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [baseUrl, id]);

  useEffect(() => {
    if (productData?.product?.category) {
      axios
        .get(`${baseUrl}productlist/${productData.product.category}`)
        .then((res) => {
          const allProducts = res.data.products || [];
          const filteredProducts = allProducts.filter((p) => p._id !== id);
          setReletedProduct(filteredProducts);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [productData, baseUrl, id]);

  console.log("releted product", reletedProduct);

  const product = productData?.product; // Main product object

  const handleAddToCart = () => {
    if (!product) {
      toast.error("Product details paoa jacche na.");
      return;
    }
    const isVariableProduct = product?.variation === "Variable";
    if (
      isVariableProduct &&
      !selectedVariant &&
      product.attributes &&
      product.attributes.length > 0
    ) {
      toast.error("Add korar age variant select korun."); // Replaced alert
      return;
    }

    const variantId = selectedVariant?._id || (selectedVariant ?
      Object.entries(selectedVariant)
        .filter(([k]) => k !== "other_attributes" && k !== "_id")
        .map(([_, v]) => v)
        .join("-") : "");

    const cartProduct = {
      product_id: product._id,
      variant_id: variantId,
      product_name: product.product_name,
      quantity: 1,
      price:
        selectedVariant?.other_attributes?.discount_price ||
        product?.discount_price,
      discount_price:
        selectedVariant?.other_attributes?.discount_price ||
        product?.discount_price,
      reguler_price:
        selectedVariant?.other_attributes?.price || product?.reguler_price,
      stock:
        selectedVariant?.other_attributes?.stock ||
        product?.stock ||
        "In stock",
      productImage: product?.productImage, // Main image for cart
      selectedAttributes: selectedVariant || {},
      cartItemId: variantId
        ? `${product._id}-${variantId}`
        : product._id,
    };
    addToCart(cartProduct);
    // toast.success(`${product.product_name} cart-e add kora hoyeche!`); // CartProvider handle korbe
  };

  const handleAddWishList = () => {
    if (!product) {
      toast.error("Product details paoa jacche na.");
      return;
    }
    const isVariableProduct = product?.variation === "Variable";
    if (
      isVariableProduct &&
      !selectedVariant &&
      product.attributes &&
      product.attributes.length > 0
    ) {
      toast.error("Wishlist-e add korar age variant select korun."); // Replaced alert
      return;
    }
    const variantId = selectedVariant?._id || (selectedVariant ?
      Object.entries(selectedVariant)
        .filter(([k]) => k !== "other_attributes" && k !== "_id")
        .map(([_, v]) => v)
        .join("-") : "");

    const wishListProduct = {
      product_id: product._id,
      variant_id: variantId,
      product_name: product.product_name,
      quantity: 1,
      price:
        selectedVariant?.other_attributes?.discount_price ||
        product?.discount_price,
      discount_price:
        selectedVariant?.other_attributes?.discount_price ||
        product?.discount_price,
      reguler_price:
        selectedVariant?.other_attributes?.price || product?.reguler_price,
      stock:
        selectedVariant?.other_attributes?.stock ||
        product?.stock ||
        "In stock",
      productImage: product?.productImage,
      selectedAttributes: selectedVariant || {},
    };
    addWishList(wishListProduct);
  };

  const handleBuyNow = () => {
    if (!product) {
      toast.error("Product details paoa jacche na.");
      return;
    }
    const isVariableProduct = product?.variation === "Variable";
    if (
      isVariableProduct &&
      !selectedVariant &&
      product.attributes &&
      product.attributes.length > 0
    ) {
      toast.error("Buy korar age variant select korun."); // Replaced alert
      return;
    }
    const variantId = selectedVariant?._id || (selectedVariant ?
      Object.entries(selectedVariant)
        .filter(([k]) => k !== "other_attributes" && k !== "_id")
        .map(([_, v]) => v)
        .join("-") : "");

    const buyProduct = {
      product_id: product._id,
      variant_id: variantId,
      product_name: product.product_name,
      quantity: 1,
      price:
        selectedVariant?.other_attributes?.discount_price ||
        product?.discount_price,
      discount_price:
        selectedVariant?.other_attributes?.discount_price ||
        product?.discount_price,
      reguler_price:
        selectedVariant?.other_attributes?.price || product?.reguler_price,
      stock:
        selectedVariant?.other_attributes?.stock ||
        product?.stock ||
        "In stock",
      productImage: product?.productImage,
      selectedAttributes: selectedVariant || {},
    };
    addToCart(buyProduct); // Add to cart first
    navigate("/checkout", { state: { product: [buyProduct] } }); // Then navigate
  };

  const { data: categoriesData } = useQuery({
    queryKey: ["categories-list-details-page"],
    queryFn: async () => {
      const token = localStorage.getItem("token");
      const res = await fetch(`${baseUrl}catagorylist`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!res.ok) throw new Error("Failed to fetch categories");
      return res.json();
    },
  });
  const categories = categoriesData?.catagories || [];

  const getCategoryName = (categoryId) => {
    const category = categories.find((cat) => cat._id === categoryId);
    return category ? category.catagoryname : "Category";
  };

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "80vh" }}
      >
        <div
          className="spinner-border text-danger"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="container text-center py-5">
        <h2 className="mb-3">Product Not Found</h2>
        <Link to="/shop" className="btn btn-danger">
          Go to Shop
        </Link>
      </div>
    );
  }

  const displayPrice =
    selectedVariant?.other_attributes?.discount_price ||
    product?.discount_price;
  const regularPrice =
    selectedVariant?.other_attributes?.price || product?.reguler_price;
  const discountPercentage = calculateDiscountPercentage(
    regularPrice,
    displayPrice
  );
  const allImages = [
    product.productImage,
    ...(product.galleryImages || []),
  ].filter(Boolean); // Filter out any null/undefined images

  const breadcrumbStyle = {
    fontSize: "0.875rem",
    color: "#6c757d",
  };
  const breadcrumbLinkStyle = {
    color: "#dc3545", // Bootstrap danger color for links
    textDecoration: "none",
  };
  const breadcrumbActiveStyle = {
    color: "#343a40",
    fontWeight: 500,
  };

  const mainImageSwiperStyle = {
    border: "1px solid #dee2e6",
    borderRadius: "0.5rem",
    backgroundColor: "#fff",
    maxHeight: "500px", // Max height for main image
  };
  const mainImageStyle = {
    width: "100%",
    height: "auto", // Maintain aspect ratio
    maxHeight: "480px", // Ensure it fits within swiper
    objectFit: "contain", // Show full image, might leave empty space
    padding: "1rem", // Padding around image
  };
  const thumbImageStyle = {
    width: "100%",
    height: "80px", // Fixed height for thumbnails
    objectFit: "cover",
    cursor: "pointer",
    border: "2px solid transparent",
    borderRadius: "0.375rem",
  };
  const activeThumbStyle = {
    borderColor: "#dc3545", // Highlight active thumb
  };

  const actionButtonStyle = {
    padding: "0.8rem 2rem",
    fontSize: "1rem",
    fontWeight: "600",
    borderRadius: "50px",
    border: "none",
    transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    letterSpacing: "0.5px"
  };

  const currentVariantId = selectedVariant?._id || (selectedVariant ?
    Object.entries(selectedVariant)
      .filter(([k]) => k !== "other_attributes" && k !== "_id")
      .map(([_, v]) => v)
      .join("-") : "");

  const isInCart = cart?.some(item =>
    item.product_id === product._id &&
    (product.variation === "Variable" ? item.variant_id === currentVariantId : true)
  );

  /* Zoom Logic */
  const handleMouseEnter = (img) => {
    setZoomState((prev) => ({ ...prev, show: true, img }));
  };

  const handleMouseMove = (e) => {
    if (!mainImageRef.current) return;

    const { left, top, width, height } = mainImageRef.current.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    setZoomState((prev) => ({ ...prev, x, y }));
  };

  const handleMouseLeave = () => {
    setZoomState((prev) => ({ ...prev, show: false }));
  };

  return (
    <>
      {/* Product Details Section */}
      <section className="py-4 py-md-5" style={{ backgroundColor: "#f8f9fa", position: "relative" }}>
        <div className="container">
          {" "}
          {/* Bootstrap container */}
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb" className="mb-4" style={breadcrumbStyle}>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/" style={breadcrumbLinkStyle}>
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/shop" style={breadcrumbLinkStyle}>
                  Shop
                </Link>
              </li>
              {product.category && (
                <li className="breadcrumb-item">
                  <Link
                    to={`/category/${product.category}`}
                    style={breadcrumbLinkStyle}
                  >
                    {getCategoryName(product.category)}
                  </Link>
                </li>
              )}
              <li
                className="breadcrumb-item active"
                aria-current="page"
                style={breadcrumbActiveStyle}
              >
                {product.product_name}
              </li>
            </ol>
          </nav>
          <div className="row g-4 g-lg-5 position-relative">
            {" "}
            {/* Bootstrap row with gutters */}
            {/* Image Gallery Column */}
            {/* Image Gallery Column */}
            {/* Image Gallery Column */}
            <div className="col-lg-6">
              {/* Add custom styles for active thumbnail */}
              <style>
                {`
                  .swiper-slide-thumb-active .thumb-container {
                    border-color: #dc3545 !important;
                    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.2);
                  }
                  .thumb-container {
                    transition: all 0.2s ease;
                  }
                  .thumb-container:hover {
                    border-color: #dee2e6;
                  }
                `}
              </style>

              <div className="mb-3 position-relative">
                {/* Lens on the main image */}
                {zoomState.show && (
                  <div
                    style={{
                      position: "absolute",
                      top: `calc(${zoomState.y}% - 75px)`, // Center the 150px lens
                      left: `calc(${zoomState.x}% - 75px)`,
                      width: "150px",
                      height: "150px",
                      backgroundColor: "rgba(255, 255, 255, 0.3)",
                      border: "1px solid rgba(0, 0, 0, 0.1)",
                      pointerEvents: "none",
                      zIndex: 10,
                      display: window.innerWidth > 991 ? "block" : "none"
                    }}
                  />
                )}

                {/* Main Zoom Window (Square/Rectangular) */}
                {zoomState.show && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: "100%",
                      width: "500px",
                      height: "500px",
                      zIndex: 1000,
                      backgroundColor: "#fff",
                      backgroundImage: `url(${zoomState.img})`,
                      backgroundPosition: `${zoomState.x}% ${zoomState.y}%`,
                      backgroundSize: "300%", // Higher zoom level for professional feel
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                      marginLeft: "15px",
                      pointerEvents: "none",
                      display: window.innerWidth > 991 ? "block" : "none"
                    }}
                  />
                )}

                {/* Main Image Swiper (Top) */}
                <div
                  ref={mainImageRef}
                  style={{ position: "relative", overflow: "hidden" }}
                  onMouseMove={handleMouseMove}
                  onMouseLeave={handleMouseLeave}
                >
                  <Swiper
                    style={{
                      ...mainImageSwiperStyle,
                      "--swiper-navigation-color": "#dc3545",
                      "--swiper-pagination-color": "#dc3545",
                      cursor: "crosshair"
                    }}
                    spaceBetween={10}
                    navigation={allImages.length > 1}
                    thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className="main-image-swiper mb-3"
                  >
                    {allImages.map((img, index) => (
                      <SwiperSlide key={`main-${index}`}>
                        <div
                          className="d-flex align-items-center justify-content-center bg-white position-relative"
                          style={{ height: "500px" }}
                          onMouseEnter={() => handleMouseEnter(img)}
                          onMouseMove={handleMouseMove}
                          onMouseLeave={handleMouseLeave}
                        >
                          <img
                            src={img || "https://placehold.co/600x500/E9ECEF/333?text=Product+Image"}
                            alt={`${product.product_name} - view ${index + 1}`}
                            style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "https://placehold.co/600x500/E9ECEF/333?text=Image+Error";
                            }}
                          />
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>


                {/* Thumbnails Swiper (Bottom) */}
                <Swiper
                  onSwiper={setThumbsSwiper}
                  spaceBetween={10}
                  slidesPerView={5}
                  freeMode={true}
                  watchSlidesProgress={true}
                  modules={[FreeMode, Navigation, Thumbs]}
                  className="thumbs-swiper"
                  breakpoints={{
                    320: { slidesPerView: 4, spaceBetween: 8 },
                    768: { slidesPerView: 5, spaceBetween: 10 },
                    1024: { slidesPerView: 6, spaceBetween: 10 },
                  }}
                >
                  {allImages.map((img, index) => (
                    <SwiperSlide key={`thumb-${index}`} style={{ height: "auto", cursor: "pointer" }}>
                      <div
                        className="thumb-container p-1 border rounded bg-white"
                        style={{ height: "80px", width: "100%", border: "2px solid transparent" }}
                      >
                        <img
                          src={img || "https://placehold.co/100x100/E9ECEF/333?text=Thumb"}
                          alt={`Thumbnail ${index + 1}`}
                          style={{ width: "100%", height: "100%", objectFit: "contain", display: 'block' }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "https://placehold.co/100x100/E9ECEF/333?text=Error";
                          }}
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
            {/* Product Info Column */}
            <div className="col-lg-6" style={{ position: "relative" }}>
              {!isShopOpen && (
                <div
                  className="shop-closed-overlay"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(255, 255, 255, 0.6)",
                    backdropFilter: "blur(4px)",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "8px",
                  }}
                >
                  <div
                    className="shop-closed-message p-3 text-center"
                    style={{
                      background: "#fff",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                      border: "2px solid #d93a38",
                      maxWidth: "100%",
                    }}
                  >
                    <h5
                      style={{
                        color: "#d93a38",
                        fontWeight: "800",
                        margin: 0,
                        fontSize: "1rem",
                      }}
                    >
                      SHOP CLOSED
                    </h5>
                  </div>
                </div>
              )}
              <div
                className="ps-lg-4"
                style={{
                  filter: !isShopOpen ? "blur(3px)" : "none",
                  pointerEvents: !isShopOpen ? "none" : "auto",
                }}
              >
                {" "}
                {/* Padding for larger screens */}
                <h1 className="h2 fw-bold mb-2" style={{ color: "#212529" }}>
                  {product.product_name}
                </h1>
                {/* Review Placeholder */}
                <div className="d-flex align-items-center mb-3">
                  <div style={{ color: "#ffc107" }}>
                    {" "}
                    {/* Yellow for stars */}
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="fas fa-star"></i>
                    ))}
                  </div>
                  <span className="ms-2 text-muted small">
                    (1 review) - Placeholder
                  </span>
                </div>
                {/* Price */}
                <div className="mb-4 d-inline-block p-3 rounded-3 bg-light border border-light-subtle">
                  <div className="d-flex align-items-center">
                    <span className="display-6 fw-bold text-danger me-3">
                      £{parseFloat(displayPrice || 0).toFixed(2)}
                    </span>
                    {regularPrice &&
                      parseFloat(regularPrice) >
                      parseFloat(displayPrice || 0) && (
                        <div className="d-flex flex-column justify-content-center">
                          <span className="text-muted text-decoration-line-through small mb-0">
                            £{parseFloat(regularPrice).toFixed(2)}
                          </span>
                          {discountPercentage > 0 && (
                            <span className="badge bg-danger rounded-pill mt-1">
                              Save {discountPercentage}%
                            </span>
                          )}
                        </div>
                      )}
                  </div>
                </div>
                {/* Stock Status */}
                <p
                  className={`mb-3 fw-medium ${(selectedVariant?.other_attributes?.stock ||
                    product.stock) === "Out of stock"
                    ? "text-danger"
                    : "text-success"
                    }`}
                >
                  Status:{" "}
                  {selectedVariant?.other_attributes?.stock ||
                    product.stock ||
                    "In stock"}
                </p>
                {/* Variant Selector */}
                {product.variation === "Variable" &&
                  product.attributes &&
                  product.attributes.length > 0 && (
                    <div className="mb-4">
                      <VariantSelector
                        product={productData}
                        setSelectedVariant={setSelectedVariant}
                      // VariantSelector-er bhitore styling thakle bhalo, noile ekhane wrapper div diye style kora jete pare
                      />
                    </div>
                  )}
                {/* Short Description */}
                {(product.short_description || product.description) && (
                  <div
                    className="text-muted mb-4"
                    style={{ fontSize: "0.95rem", lineHeight: "1.6" }}
                    dangerouslySetInnerHTML={{
                      __html:
                        product.short_description ||
                        (product.description?.length > 200
                          ? product.description.substring(0, 200) + "..."
                          : product.description),
                    }}
                  />
                )}
                {/* Action Buttons */}
                {/* Action Buttons */}
                <div className="d-grid gap-2 d-sm-flex mb-4">
                  <button
                    onClick={handleAddToCart}
                    disabled={
                      (selectedVariant?.other_attributes?.stock ||
                        product.stock) === "Out of stock"
                    }
                    className="btn btn-lg flex-grow-1"
                    style={{
                      ...actionButtonStyle,
                      backgroundColor: "#dc3545",
                      color: "white",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#c82333")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "#dc3545")
                    }
                  >
                    <i className="fas fa-cart-plus me-2"></i> {isInCart ? "Added in Cart" : "Add to Cart"}
                  </button>
                  <button
                    onClick={handleBuyNow}
                    disabled={
                      (selectedVariant?.other_attributes?.stock ||
                        product.stock) === "Out of stock"
                    }
                    className="btn btn-lg btn-dark flex-grow-1"
                    style={actionButtonStyle}
                  >
                    <i className="fas fa-bolt me-2"></i> Buy Now
                  </button>
                  <button
                    onClick={handleAddWishList}
                    title={
                      isAddedWishlist
                        ? "Added to Wishlist"
                        : "Add to Wishlist"
                    }
                    className="btn btn-lg btn-outline-danger"
                    style={{
                      ...actionButtonStyle,
                      backgroundColor: "transparent",
                      color: "#dc3545",
                      borderColor: "#dc3545",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor =
                        "rgba(220, 53, 69, 0.1)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                    }}
                  >
                    <i
                      className={`${isAddedWishlist ? "fas" : "far"
                        } fa-heart`}
                    ></i>
                  </button>
                </div>
                {/* Meta Information */}
                <div className="text-muted small">
                  {product.sku && (
                    <p className="mb-1">
                      <strong>SKU:</strong>{" "}
                      {selectedVariant?.other_attributes?.sku || product.sku}
                    </p>
                  )}
                  {product.category && (
                    <p className="mb-1">
                      <strong>Category:</strong>{" "}
                      <Link
                        to={`/category/${product.category}`}
                        style={{ color: "#dc3545", textDecoration: "none" }}
                      >
                        {getCategoryName(product.category)}
                      </Link>
                    </p>
                  )}
                  {product.tags && product.tags.length > 0 && (
                    <p className="mb-1">
                      <strong>Tags:</strong>{" "}
                      {product.tags.map((tag, index) => (
                        <React.Fragment key={index}>
                          <Link
                            to={`/tag/${tag.trim()}`}
                            style={{ color: "#dc3545", textDecoration: "none" }}
                          >
                            {tag.trim()}
                          </Link>
                          {index < product.tags.length - 1 ? ", " : ""}
                        </React.Fragment>
                      ))}
                    </p>
                  )}
                </div>
                {/* Social Share */}
                <div className="mt-4 pt-3 border-top">
                  <strong className="small me-2">Share:</strong>
                  <Link
                    to="#"
                    title="Facebook"
                    className="btn btn-outline-secondary btn-sm me-2"
                    style={{ borderColor: "#adb5bd" }}
                  >
                    <i className="fab fa-facebook-f"></i>
                  </Link>
                  <Link
                    to="#"
                    title="Twitter"
                    className="btn btn-outline-secondary btn-sm me-2"
                    style={{ borderColor: "#adb5bd" }}
                  >
                    <i className="fab fa-twitter"></i>
                  </Link>
                  <Link
                    to="#"
                    title="Pinterest"
                    className="btn btn-outline-secondary btn-sm me-2"
                    style={{ borderColor: "#adb5bd" }}
                  >
                    <i className="fab fa-pinterest"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Description/Reviews Tabs Section */}

      <section className="py-5" style={{ backgroundColor: "rgb(248, 249, 250)" }}>
        <div className="container">
          <div className="d-flex align-items-center mb-4">
            <h3 className="fw-bold m-0 position-relative" style={{ color: "#2c3e50" }}>
              You Might Also Like
              <span style={{
                position: 'absolute',
                bottom: '-10px',
                left: '0',
                width: '40px',
                height: '3px',
                backgroundColor: '#dc3545',
                borderRadius: '2px'
              }}></span>
            </h3>
          </div>
          <div style={{ position: "relative" }}>
            {!isShopOpen && (
              <div
                className="shop-closed-overlay"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(255, 255, 255, 0.6)",
                  backdropFilter: "blur(4px)",
                  zIndex: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "8px",
                }}
              >
                <div
                  className="shop-closed-message p-4 text-center"
                  style={{
                    background: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                    border: "2px solid #d93a38",
                    maxWidth: "80%",
                  }}
                >
                  <h3 style={{ color: "#d93a38", fontWeight: "800", margin: 0 }}>
                    SHOP IS CURRENTLY CLOSED
                  </h3>
                  <p className="mb-0 mt-2 text-muted">
                    We are not accepting orders at the moment. Please check back
                    later.
                  </p>
                </div>
              </div>
            )}
            <div
              className="row g-4"
              style={{
                filter: !isShopOpen ? "blur(5px)" : "none",
                pointerEvents: !isShopOpen ? "none" : "auto",
              }}
            >
              {reletedProduct.slice(0, 4).map((singleProduct) => (
                <div
                  key={singleProduct._id}
                  className="col-12 col-sm-6 col-md-4 col-lg-3"
                >
                  <ProductCard item={singleProduct} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductDetails;
